export const SESSION_END_PROGRESS_FAST_CAP = 0.8;
export const SESSION_END_PROGRESS_FAST_MS = 40_000;
export const SESSION_END_PROGRESS_SLOW_MS = 30 * 60 * 1000;
export const SESSION_END_PROGRESS_RUSH_LERP = 0.12;

export const SESSION_END_SAFETY_TIMEOUT_MS =
	SESSION_END_PROGRESS_FAST_MS + SESSION_END_PROGRESS_SLOW_MS + 60_000;

export const resolveSessionEndTransitionTimeProgress = (
	elapsedMs: number,
): number => {
	if (elapsedMs <= SESSION_END_PROGRESS_FAST_MS) {
		return (
			(elapsedMs / SESSION_END_PROGRESS_FAST_MS) *
			SESSION_END_PROGRESS_FAST_CAP
		);
	}

	const slowElapsed = elapsedMs - SESSION_END_PROGRESS_FAST_MS;
	const slowRatio = Math.min(slowElapsed / SESSION_END_PROGRESS_SLOW_MS, 1);

	return (
		SESSION_END_PROGRESS_FAST_CAP +
		slowRatio * (1 - SESSION_END_PROGRESS_FAST_CAP)
	);
};

export const rushSessionEndTransitionProgress = (current: number): number => {
	const next = current + (1 - current) * SESSION_END_PROGRESS_RUSH_LERP;
	return next >= 0.999 ? 1 : next;
};
